import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  userData: {},
  pageFlag: 'create'
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setUserDataAction: (state, action) => {
      state.userData = action.payload
    },
    setUserPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setUserDataAction, setUserPageFlagAction } = userSlice.actions

// Selectors
export const selectUserData = (state) => state.user.userData
export const selectUserPageFlag = (state) => state.user.pageFlag

// Reducer
export default userSlice.reducer